import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//PAGES
import { PedidoGestorPage } from '../pedidoGestor/pedidoGestor';
import { WelcomePage } from '../welcome/welcome';
import { ChangepassPage } from '../changepass/changepass';

//PROVIDERS
import { Services, Tools, User } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-listaGestor',
  templateUrl: 'listaGestor.html',
})

export class ListaGestorPage {
  pedidos:any = [];
  pedidosorig:any = [];
  emptylist:boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private user: User,
    private services: Services,
    private tools: Tools
  ) {
  }

  ionViewDidLoad(){
    // if(!this.user.getUser().changePass){
    //   this.navCtrl.push(ChangepassPage);
    //   return;
    // }
    this.loadList();
  }

  loadList(){
    var user = this.user.getUser();
    console.log('[user]: ',user)
    var loading = this.tools.showLoading('Carregando');
    loading.present();
    let query = {ativo:true,'pedido.statusText':{$in:['Aguardando Entrega','Aguardando Entrega com Itens Indisponíveis']},'entrega.status':'Aguardando Liberação',lojaId:user.lojaId+''}
    console.log('query: ',query)
    // let query = {ativo:true,'pedido.dataText':new Date().toLocaleDateString('pt-BR'),'pedido.statusText':{$in:['Aguardando Entrega','Aguardando Entrega com Itens Indisponíveis']},'entrega.status':'Aguardando Liberação'}
    this.services.getData('cadPedidos',query,(result)=>{
      console.log(result);
      let newdata = result.data.map(e=>{
        e.filter = e.cliente.nome+' - '+e.pedido.codigo;
        return e;
      });
      this.pedidosorig = newdata.concat([]);
      this.pedidos = newdata.concat([]);
      if(result.data.length == 0){this.emptylist = true;}
      loading.dismiss();
      console.log(this.pedidos);
    });
  }

  openPedido(pedido){
    this.navCtrl.push(PedidoGestorPage,{item:pedido});
  }

  logout(){
    var x = confirm('Sair?');
    if(!x){return}

    this.navCtrl.setRoot(WelcomePage);
  }

  getItems(event){
    if(event.target.value=='' || !event.target.value){this.pedidos=this.pedidosorig}
    else{
      this.pedidos = this.pedidosorig.filter(item=>{
        return (item.filter).toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/listaGestor/listaGestor.ts